export type Reason = {
    employeeId : number;
    startOfWeek : string;
    reason : string;
};

type State = Reason[] | null;

type InitialLoadAction = {
    type : 'initialLoad';
    payload : {
        reasons : Reason[] | null;
    };
};

type UpdateAction = {
    type : 'update';
    payload : {
        employeeId : number;
        startOfWeek : string;
        reason : string;
    };
};

type RefreshAction = {
    type : 'refresh';
    payload : {
        employeeId : number;
        reasons : Reason[];
    };
};

export type ReasonsAction = InitialLoadAction | UpdateAction | RefreshAction;

export const reasonsReducer = (state : State, action : ReasonsAction) : State => {
    if (action.type === 'initialLoad') {
        return action.payload.reasons;
    }

    if (!state) {
        return state;
    }

    switch (action.type) {
        case 'update':
            return state
                .filter(reason => !(
                    reason.employeeId === action.payload.employeeId && reason.startOfWeek === action.payload.startOfWeek
                ))
                .concat(action.payload);

        case 'refresh':
            return state
                .filter(reason => reason.employeeId !== action.payload.employeeId)
                .concat(...action.payload.reasons);
    }

    return state;
};
